import dayjs from "dayjs";

// Real ESM (.mjs), dependency-free apart from dayjs (no Firebase/MUI/React)
// on purpose: it needs to be `import()`-able by a bare `node` child process
// (see buildMonthYearName.positiveOffset.test.js) without dragging in
// EmissionsCsvDownload.js's heavy import chain or going through Babel. It
// was originally plain CommonJS for the same reason -- but Vite/Rollup
// statically analyzes local source files for literal `export` keywords
// rather than interop-detecting `module.exports` the way webpack did, so a
// CJS version of this file built fine under CRA but either failed the Vite
// production build outright (a named or default import) or -- worse --
// built "successfully" with a bare `require()` call left in the shipped
// bundle, which throws `ReferenceError: require is not defined` and blanks
// the entire app the instant a browser tries to run it (there is no
// `require` global outside Node). `.mjs` is unambiguous ESM to every tool
// involved (Vite, Node's own loader, Jest's default `moduleFileExtensions`),
// so this needs no CJS/ESM interop anywhere, in either direction.
//
// `date` is a recurring emission's month-anchor. For `source: "recurring"`
// rows (the only caller, EmissionsCsvDownload.js's splitUtilitiesEmissions)
// this always comes from @aclymatepackages/calcs/recurring's
// `new Date(year, month, 1)` -- the customer's own browser-LOCAL month
// start, never UTC-anchored. Reading it back with bare dayjs() keeps the
// label on the same calendar month it was built from in every timezone; a
// UTC read (dayjs.utc()) mislabels the month for any customer at a positive
// UTC offset (e.g. a Sydney-local Jan 1 midnight anchor renders as
// "December" instead of "January").
export const buildMonthYearName = (date) =>
  `${dayjs(date).format("MMMM")} ${dayjs(date).year()}`;
